<template>
	<div class="box-page">

		<i-modal ref="modalConfirmation" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="$refs.modalConfirmation.modalHide()" @confirm="confirmProses"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alert" :title="success ? 'Berhasil' : 'Oops!'" :success="success" @remove="$refs.modalAlert.modalHide()"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
				<div class="col-12 col-lg-12 pl-0 pr-0 pr-lg-3">
                    <div class="col-12 pl-0 pr-0">
                        <div class="col-12 p-4 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
                            <div class="col-12 col-md-6 pl-0 pb-1 mt-auto mb-4">
								<div class="col-12 pl-0 pr-0 font-size-sm-12 font-size-14">Penukaran Serial</div>
							</div>
							<div class="col-12 px-0">
                                <div class="col-12 col-sm-4 px-0 d-flex">
                                    <div class="pb-2 font-size-10">Pilih RDC Tujuan.</div>
                                </div>
								<div class="col-12 col-sm-4 px-0 pb-3 d-flex">
                                    <div class="col-9 px-0">
                                        <v-select v-model="selectedRDC" :options="dataWarehouse" appendToBody class="font-size-10 rounded-cus focus-me" label="warehouse_name" :reduce="el => el.warehouse_id">
                                            <template v-slot:no-options>
                                                Saat ini tidak ada RDC yang tersedia
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
							<div class="col-12 px-0">
                                <div class="col-12 col-sm-4 px-0 d-flex">
                                    <div class="pb-2 font-size-10">Silahkan Pilih Produk yang ingin ditukar.</div>
                                </div>
								<div class="col-12 col-sm-4 px-0 pb-3 d-flex">
                                    <div class="col-9 px-0">
                                        <v-select v-model="selectedProduct" multiple :options="dataProduk" appendToBody class="font-size-10 rounded-cus focus-me" label="product_code" @input="getSerial">
                                            <template v-slot:no-options>
                                                Saat ini tidak ada produk yang tersedia
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 pl-0" v-for="(product, index) in selectedProduct" :key="index">
                                <!-- Pencarian Selected -->
                                <div class="col-8 font-size-10 label-detail-product">
									<span>Maksimal {{product.product_code}} {{product.stock_pos}}</span>
								</div>
                                <div class="col-12 px-0 my-2 d-flex">
                                    <div class="col-11 px-0">
                                        <v-select v-model="selectedProduct[index].serialInput" :options="filteredSerial.filter(el => el.stock_serial_type == product.product_is_serial)" appendToBody class="font-size-10 rounded-cus focus-me" label="stock_serial_value" taggable :create-option="el => ({ stock_serial_value: el})" :reduce="el => `${el.stock_serial_value}`">
                                            <template v-slot:no-options>
                                                Saat ini tidak ada serial yang tersedia
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-1 px-0">
                                        <button class="btn pr-0 btn-link-blue btn-hover no-box-focus" @click="checkMLMSerial(index)">
                                            <div class="font-size-9 font-size-sm-9">Pilih</div>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-12 mt-2 pt-2 pb-2 bg-white border-2 rounded-cus">
									<span>Total Terpilih ({{product.serial ? product.serial.length : 0}})</span>
                                    <!-- Serial  -->
                                    <div class="col-12 pl-0 pr-0">
                                        <div v-if="!product.serial" class="col-12 pl-0 pr-0 mt-2 mb-2 text-center serial-body">
                                            <img class="pt-5" src="/assets/transaction/empty-serial-icon.svg">
                                            <div class="font-size-10 pt-2">Belum ada Serial terpilih</div>
                                        </div>
                                        <div v-else class="col-12 pl-0 pr-0 mt-2 mb-2 serial-body" :id="'serial-body-selected' + index">
                                            <div :id="'container-selected' + index">
                                                <div class="container-serial d-flex" style="padding-left: 0px;" v-for="(value, indexSerial) in product.serial" :key="indexSerial">
                                                    <span class="serial-item font-size-10">{{value}}</span>
                                                    <button @click="remove(index, indexSerial)" type="button" class="btn btn-del-serial text-white no-box-focus"><i class="fas fa-minus-circle font-size-10"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

							<div class="col-12 text-right mt-2" v-if="selectedProduct.length > 0">
								<button class="col-3 btn bg-blue color-white no-box-focus" @click="proses">
									<div class="d-flex justify-content-center">
										<div class="mr-2 font-size-11 font-weight-bold">Proses</div>
										<i class="fas fa-arrow-right mt-1"></i>
									</div>
								</button>
							</div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
export default {
	components: {
		IModal, AlertModal
	},
	data() {
		return {
			confirmMessage: '',
			alert: '',
			success: 'alert',
			selectedRDC: '',
            selectedProduct: [],
			selectedSerialType: [],
			selectedSerial: [],
		}
	},
	computed: {
        ...mapState('serial', ['dataProduk', 'dataSerial', 'dataWarehouse']),

		filteredSerial() {
			return this.dataSerial.filter(el => {
				return !this.selectedSerial.includes(el.stock_serial_value)
			})
		},
	},
	methods:{
		...mapActions('serial', ['getProduct', 'getWarehouse', 'getListSerial', 'checkSerialMLM', 'requestConvert']),
		...mapMutations('serial', ['reset']),

		getSerial(data) {
			data.forEach(el => {
				if (!this.selectedSerialType.includes(el.product_is_serial)) {
					this.selectedSerialType.push(el.product_is_serial)
					let params = [{
							value: el.product_is_serial,
							comparison: '=',
							type: 'string',
							field: 'stock_serial_type',
						}, {
							value: '0',
							comparison: '=',
							type: 'string',
							field: 'stock_serial_status',
						}];
					this.getListSerial(this.queryString({params: params}))
				}
			})
		},
		checkMLMSerial(index) {
			if(!this.selectedProduct[index].serialInput)
				return;

			this.checkSerialMLM({
				serial: this.selectedProduct[index].serialInput
			}).then((result) => {
				this.selectedProduct[index].serialInput = ''
				let serial = Array.isArray(this.selectedProduct[index].serial) ? this.selectedProduct[index].serial : [];
				let validSerial = [];
				result.forEach((el) => {
					if(!this.selectedSerial.includes(el.serial)) {
						validSerial.push(el.serial)
					}
				})
				this.selectedProduct[index].serial = [... validSerial, ... serial]
			})
		},
		remove(index, indexSerial) {
			let data = [... this.selectedProduct[index].serial]
			data.splice(indexSerial, 1)
			this.selectedProduct[index].serial = data
		},
		proses(sdo_id) {
			this.sdo_id = sdo_id
			this.confirmMessage = 'Apakah anda yakin ingin memproses penukaran serial?'
			this.$refs.modalConfirmation.modalShow()
		},
		confirmProses() {
			let params = {
				product: this.selectedProduct.map(el => {
					return {
						'product_code': el.product_code,
						'serial' : el.serial
					}
				}),
				warehouse_id: this.selectedRDC
			}
			this.requestConvert(params).then((message) => {
				this.$refs.modalConfirmation.modalHide()
				this.alert = message
				this.success = true
				this.clearData()
				this.$refs.modalAlert.modalShow()
			}).catch( ({ data }) => {
				if(data.message == "error_validation") {
					this.alert = Object.values(data.data).join(', ')
				} else if (data.message == "error_multiple_alert") {
					this.alert = data.data.error.join(', ')
				} else {
					this.alert = data.message
				}

				this.success = false
				this.$refs.modalConfirmation.modalHide()
				this.$refs.modalAlert.modalShow()
			})
		},
		clearData() {
			this.selectedProduct.forEach(el => {
				el.serial = []
			})
			this.selectedProduct = []
			this.selectedSerial = []
		}
	},
	created() {
        this.getProduct();
		this.getWarehouse();
		this.$store.dispatch('setPageTitle', 'Penukaran Serial');
	},
	beforeDestroy() {
		this.reset()
	},
	mounted() {
	},
	watch: {
		selectedProduct: {
			handler(val) {
				let selectedSerial = []
				val.forEach(el => {
					let serial = Array.isArray(el.serial) ? el.serial : [];
					selectedSerial = [...selectedSerial, ...serial]
				})
				this.selectedSerial = selectedSerial
			},
			deep: true
		},

	}
};
</script>
